// Checks the "local@domain.tld" shape via plain index scanning instead of a
// regex — a backtracking pattern here (e.g. /^[^\s@]+@[^\s@]+\.[^\s@]+$/)
// keeps getting flagged by static analysis as super-linear regardless of how
// the character classes are shaped, since the domain-label class unavoidably
// overlaps the literal "." that follows it. Index scanning has no
// backtracking to exploit at all.
function hasEmailShape(email: string): boolean {
  if (/\s/.test(email)) return false;

  const at = email.indexOf("@");
  if (at <= 0 || at !== email.lastIndexOf("@")) return false;

  const domain = email.slice(at + 1);
  const dot = domain.lastIndexOf(".");
  return dot > 0 && dot < domain.length - 1;
}

export const validateEmail = (email: string) => {
  if (email.length === 0) {
    return { isValid: false, key: "enterEmail" };
  }

  if (!hasEmailShape(email)) {
    return { isValid: false, key: "validEmail" };
  }

  return { isValid: true, key: "validEmail" };
};

export const validateOTP = (otp: string) => {
  if (typeof +otp !== "number") {
    return { isValid: false, key: "validOTP" };
  }
  if (!/^\d{4}$/.test(otp)) {
    return { isValid: false, key: "validOTP" };
  }
  return { isValid: true, key: "" };
};

export const validateForm = (form: any) => {
  const hasfalsyValue = Object.values(form).filter((value: unknown) => !value);
  return hasfalsyValue.length > 0;
};

export function isFalsyButNotZero(value: any) {
  return ![false, null, undefined, NaN, ""].includes(value);
}

export const isLetters = (str: any) => /^[A-Za-z]*$/.test(str);

export const validateCreditScore = (creditScore: any) => {
  if (!creditScore) {
    return  "enterCreditScore";
  }
  if (isNaN(+creditScore) || isLetters(creditScore)) {
    return  "enterValidNumber";
  }
  if (Number(creditScore) < 300 || Number(creditScore) > 855) {
    return  "enterValidCreditScore";
  }
  if (Number(creditScore) < 0) {
    return  "cannotBeNegative";
  }
  if (!creditScore?.trim().length || creditScore?.includes(".")) {
    return  "validValue";
  }
  return  "";
}